// translations/pages/events/sv.js
// Labels of the events section and page, and the texts of every event by its id
// from config/events.cjs. Dates are not written here; the pages format them.

export const eventsPageSV = {
  title: 'Evenemang',
  upcoming: 'Kommande evenemang',
  past: 'Tidigare evenemang',
  all: 'Alla evenemang',
  items: {
    wikki26: {
      title: 'WiKKI26 – Wildaukonferensen om artificiell intelligens',
      description: 'pAIoneer Labs deltog som utställare vid Technische Hochschule Wildau. I montern handlade det om hur lokal AI-infrastruktur byggs upp i företag och organisationer: datasuveränitet, inbyggt dataskydd och AI som uppfyller lagkraven, utan onödigt beroende av externa molnlösningar.'
    }
  }
};
